import styled from 'styled-components';

const WebstoreSetupWizardStyled = styled.div`
    height: 100%;
    width: 100%;
`;

export { WebstoreSetupWizardStyled };
